import { render, staticRenderFns } from "./TrafficMessageTurnaroundTrainsText.vue?vue&type=template&id=291210fd"
import script from "./TrafficMessageTurnaroundTrainsText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageTurnaroundTrainsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports